import React from 'react';
import ProductList from '../components/products/ProductList';

const BodyMists = () => {
  return (
    <ProductList
      categorySlug="bodymists"
      categoryName="Body Mists"
      categoryDescription="Stay fresh all day with our refreshing body mists. Light, uplifting scents for everyday wear."
    />
  );
};

export default BodyMists;